import Vue from "vue";
import firebase from "firebase";
import VueFire from "vuefire";
import Vuetify from "vuetify";
import "../node_modules/vuetify/dist/vuetify.min.css";
import App from "@/App";
import router from "@/router/";
import store from "@/store/";
import JsonExcel from "vue-json-excel";
import JGLogoIcon from "./icons/JG_Logo.vue";

Vue.config.productionTip = false;

Vue.use(Vuetify);
const opts = {
	dark: false,
	theme: {
		themes: {
			light: {
				primary: "#1198aa",
				secondary: "#f2f2f2",
				accent: "#8c9eff",
				error: "#b71c1c",
				chart0: "#1198aa",
				chart1: "#88CCD5",
				chart2: "#D14B26",
				chart3: "#E8A593",
				chart4: "#09BC03",
				chart5: "#84DE81",
			}
		}

	},
	icons: {
		values: {
			jglogo: {
				component: JGLogoIcon
			}
		}
	}
};

// Connect to Firebase DB with VueFire
Vue.use(VueFire);
let database = firebase.database();

Vue.component("downloadExcel", JsonExcel); // Kill this

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	store,
	template: "<App/>",
	components: {
		App
	},
	firebase: {
		database: database.ref()
	},
	vuetify: new Vuetify({...opts})
});



// WEBPACK FOOTER //
// ./src/main.js